<template>
    <div>
        <Title :strong="2">评论区（共{{ total }}条评论）</Title>
        <div v-show="hasLogin" class="writeboard">
            <div class="help">
                <a-button type="link" @click="() => showHelp = !showHelp">
                    复杂评论预览<a-icon :type="showHelp ? 'caret-up' : 'caret-down'" />
                </a-button>
                <div v-show="showHelp">
                    <!-- 插入图片格式：[img]图片地址[/img]，如[img]https://h5mota.com/favicon.ico[/img]。<br/>
                    这里暂不支持上传图片。如有需要，可移步论坛进行上传。
                    为防止大图刷屏，每张图将强制放缩到最大高度200px。
                    请自觉维护评论区的整洁，以免封号后又要重新注册等一个月的时间。
                    超链接：[url]地址[/url]或[url=地址]文字[/url]，如[url]https://h5mota.com/[/url]或[url=https://h5mota.com/]H5魔塔网站[/url]。
                    B站视频：[bilibili]//player.bilibili.com/...[/bilibili]。
                    请插入分享的B站视频地址，必须是//player.bilibili.com/player.html?aid=数字(&bvid=...)&cid=数字&page=1的形式。
                    插入视频的条件同插入图片。
                    详细说明请参见<a href="http://bbs.17173.com/thread-11196009-1-1.html" target="_blank">此处</a>。 -->
                    高级用法说明:<br/>
                    <ul>
                        <li>评论区支持emoji，如🙂🙃之类。（文明人，拒绝🐎）</li>
                        <li>字体颜色：[color=颜色]文字[/color]，如[color=red]红色[/color]，[color=#00FF00]绿色[/color]。</li>
                        <li>字体大小：[size=大小]文字[/size]，如[size=20]字体大小20px[/size]。</li>
                        <li>网址：[url]粗体文字[/url]或者[url=xxx]介绍[/url]</li>
                        <li>粗体和斜体：[b]粗体文字[/b]和[i]斜体文字[/i]。</li>
                    </ul>
                    <div class="preview" v-html="parseText(text)"></div>
                </div>
            </div>
            <a-textarea v-model="text" ref="writeboard" auto-size></a-textarea>
            <div class="optbar">
                <a-button @click="submit" type="primary">我也说一句</a-button>
            </div>
        </div>
        <a-result v-show="!hasLogin" title="尚未登录，请登录后回复">
            <template #icon></template>
            <template #extra>
            <a-button type="primary">
                <a href="/user/login.html?from">登录</a>
            </a-button>
            </template>
        </a-result>
        <a-list
            class="comment-list"
            item-layout="horizontal"
            :data-source="comments"
        >
            <a-list-item slot="renderItem" slot-scope="comment" :id="`p${ comment.id }`">
                <Comment :comment="comment" @edit="openEditDialog"></Comment>
            </a-list-item>
        </a-list>
    </div>
</template>

<script>
import Title from '@/components/Title.vue';
import Comment from '../components/Comment.vue';
import { mapState } from 'vuex';
import { createFormData, getReason, parseText } from '../../../utils/utils';
import axios from 'axios';

export default {
    props: {
        comments: Array,
    },
    data: () => ({
        text: '',
        showHelp: false,
    }),
    provide() {
        return {
            commentBoard: this,
        }
    },
    computed: {
        ...mapState({ hasLogin: 'hasLogin' }),
        total() {
            return this.comments.reduce((sum, e) => {
                return sum + e.replies.length + 1;
            }, 0)
        }  
    },
    methods: {
        parseText,
        openEditDialog() {

        },
        async submit() {
            const content = this.text;
            this.appendComment({ pid: 0, content, replyto: 0 });
        },
        async appendComment({ pid, content, replyto }) {
            try {
                const { data } = await axios
                    .comment("/backend/tower/discussion/appendComment.php", createFormData({
                        pid, content, replyto
                    }));
                if (data.code == 0) {
                    this.$message.success('回复成功');
                    window.location.reload();
                } else {
                    const reason = getReason(data.code);
                    this.$message.error(`回复失败: ${ reason }`);
                }
            } catch (e) {
                this.$message.error(`回复失败, 错误: ${ e }`);
            } finally {
                this.replying = false;
            }
        },
        async deleteComment(id) {
            this.$confirm({
                title: '确认要删除回帖吗？',
                content: h => <div style="color:red;">一旦删除后无法恢复</div>,
                onOk: async() => {
                    const { data } = await axios
                        .comment("/backend/bbs/deletecomment.php", createFormData({
                            id
                        }));
                    if (data.code == 0) {
                        this.$message.success('删除成功');
                        window.location.reload();
                    } else {
                        this.$message.error('删除失败');
                    }
                },
                onCancel() {
                    //
                },
            });
        },
        async deleteCommentByAdmin(id) {
            const reason = prompt('确认要删除回帖吗？\n你正在动用管理权限，请给出删除理由', '');
            if (reason === null) return;
            const { data } = await axios
                .comment("/backend/tower/discussion/deleteComment.php", createFormData({
                    id, reason
                }));
            if (data.code == 0) {
                this.$message.success('删除成功');
                window.location.reload();
            } else {
                this.$message.error('删除失败');
            }
        }
    },
    components: {
        Comment,
        Title,
    },
}
</script>

<style lang="less" scoped>
.comment-list {
    margin: 0 5px;
}
.writeboard {
    margin: 10px;
}
.optbar {
    margin: 10px;
    text-align: right;
}
.help {
    text-align: left;
}
.preview {
    margin: 5px;
    padding: 5px;
    background-color: #DDDDDD;
    font-size: 16px;
    border-radius: 3px;
}
</style>
